import {LifestylePreviewCategoryFragment} from '#apollo/schema';

/**
 * Maps the CategoryAssessments as returned from the useLifestylePreview query
 * to a smaller type with less nesting, for simpler prop-drilling and typing.
 */
export const getPreviewCategories = (categories: LifestylePreviewCategoryFragment[] = []) =>
  categories.map(({id, categoryScore, maxCategoryScore, category}, i) => ({
    id,
    maxCategoryScore,
    categoryScore,
    title: category.title,
  }));
